(function() {
  function fixArticle() {
    var article = document.querySelector('.article--content.rte') || document.querySelector('.article--content .rte');
    if (!article) return;
    article.style.cssText += ';overflow:hidden!important;max-width:100%!important;box-sizing:border-box!important;';
    var tables = article.querySelectorAll('table');
    tables.forEach(function(t) {
      t.style.cssText += ';width:100%!important;max-width:100%!important;table-layout:fixed!important;';
    });
    var tds = article.querySelectorAll('td, th');
    tds.forEach(function(td) {
      td.style.cssText += ';word-wrap:break-word!important;overflow-wrap:break-word!important;overflow:hidden!important;';
    });
    var imgs = article.querySelectorAll('img');
    imgs.forEach(function(img) {
      img.style.cssText += ';max-width:100%!important;height:auto!important;';
    });
    var iframes = article.querySelectorAll('iframe[src*="youtube"], iframe[src*="vimeo"]');
    iframes.forEach(function(iframe) {
      if (iframe.parentNode.classList.contains('article-video-wrap')) return;
      iframe.removeAttribute('height');
      iframe.removeAttribute('width');
      iframe.removeAttribute('style');
      var wrapper = document.createElement('div');
      wrapper.style.cssText = 'width:100%;max-width:800px;aspect-ratio:16/9;margin:24px auto;border-radius:8px;overflow:hidden;';
      wrapper.className = 'article-video-wrap';
      iframe.parentNode.insertBefore(wrapper, iframe);
      wrapper.appendChild(iframe);
      iframe.style.cssText = 'width:100%!important;height:100%!important;border:0;display:block;';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixArticle);
  } else {
    fixArticle();
  }
})();